import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginRight, setMarginRight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.032 * cardRef.current.clientWidth));
        setLetterSpacing(0.003 * cardRef.current.clientWidth);
        setLineHeight(0.07 * cardRef.current.clientWidth);
        setMarginRight(-0.15 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginRight: `${marginRight}px`,
        }}
      >
        <p>Vlaknaste su stvari</p>
        <p>koje govore, ostvaruju, poriču.</p>
        <p>Poroci i unuci koje utiskujem</p>
        <p>u protočnost dana</p>
        <p>da bih bila match-matchy.</p>
        <p>To što izgleda kao da blijedim</p>
        <p>a gorim, jer nije na broju.</p>
        <p>Sve što slijedim i pokušavam na svoju</p>
        <p>ruku i srce, ruku na srce,</p>
        <p>ne znam što slijedi.</p>
        <p>Crvenim gdje ne trebam</p>
        <p>i ne smijem to što grebem,</p>
        <p>ali boli, boli, boli.</p>
      </div>
    </div>
  );
}
